import { render, staticRenderFns } from "./SnapGridOnTopBarIcon.vue?vue&type=template&id=0b7a7d4a&"
import script from "./SnapGridOnTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./SnapGridOnTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports